angular.module('festzelt-os.modules.users', [
    'ui.router',
    'festzelt-os.components',
])

require('./routes');

require('./components/al-users-grid-view/component');

require('./workflows');

require('./factories/user-factory');
require('./store/users');

// require('./components/al-users-grid-view/component');



// WEBPACK FOOTER //
// ./src/app/modules/users/module.js